export class Vendor {
    vendorid: number;
    vendorname: string;
    vendoraddress: string;
    vendorphone: number;
    vendormailid: string;
    stateid: number;
    cityid: number;
    pincode:number;
    gstno: string;
	hsncode:string;
    panno: string;
	active: number;
}